module.exports = __webpack_public_path__ + "static/media/tesla.fd47936b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/tesla.png
// module id = 319
// module chunks = 0